/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'components/Buttons/Select/Select';
import {
	createFormData,
	generateHash,
	listTypeRegister,
	isRouteEditMonitoring,
	isLatitude,
	isLongitude,
	isCoordsInvalid,
	convertLatLong,
	getDMS
} from 'helpers/utils';
// import { getCoordsOnMap } from 'store/actions/systemActions';
// import MyLocationIcon from '@mui/icons-material/MyLocation';
import BalloonDoubtsGlobal from 'components/BalloonDoubtsGlobal';
import CustomInput from 'components/CustomInput';
import CustomTextArea from 'components/CustomTextArea';
import AudioRecorder from 'components/AudioRecorder';
import { color } from 'styles/Theme';
import Load from 'components/Load/Load';
import { olMap } from 'components/Map/ControlMap';
import { clearVector, onLoadMonitoring } from 'store/actions/mapActions';
import { finishEdit } from 'store/actions/editDataUserOnMapAction';
import ImageUploading from 'components/ImageUploading';
import { editDataMonitoring } from 'store/actions/monitoringDataAction';
import { useAlertTraditionlUseContext } from 'services/map/alert.context';
import { transform } from 'ol/proj';

import * as S from './styled';

export default function EditAlertTradicionalTrackEndWhereIBeen({ type = '' }) {
	const dispatch = useDispatch();

	const { dataToEdit } = useSelector((state) => state.editDataUserOnMap);

	const { routeMonitoring, loadingUpdate } = useSelector((state) => state.monitoring);
	const { dataUser } = useSelector((state) => state.dataUserToShowOnMap);
	const { coordinates } = useSelector((state) => state.system);

	// armazena a lista de alertas ou usos tradicionais no select
	const [listType, setListType] = useState([]);

	// Estados que são inseridos no formulário
	const [id, setId] = useState(0);
	const [typeSelected, setTypeSelected] = useState({});
	const [nameWhereIBeen, setNameWhereIBeen] = useState('');
	const [description, setDescription] = useState({});
	const [audioRecorderFile, setAudioRecorderFile] = useState(null);
	const [audioByMonitoring, setAudioByMonitoring] = useState({});

	const { lat, setLat, long, setLong } = useAlertTraditionlUseContext();
	const [gms, setGms] = useState('');
	const [isOnchangeGms, setisOnchangeGms] = useState(false);
	const [extent, setExtent] = useState(false);
	/* const [lat, setLat] = useState('');
	const [long, setLong] = useState(''); */
	const [isImages, setIsImages] = useState([]);
	const [imagesFiles, setImagesFiles] = useState([]);

	// Estados que controlam os erros
	const [locationEmpty, setLocationEmpty] = useState(false);
	const [nameWhereIBeenEmpty, setNameWhereIBeenEmpty] = useState(false);
	const [typeSelectedEmpty, setTypeSelectedEmpty] = useState(false);

	const isTrackOrWhereIBenn = routeMonitoring === 'tracks' || routeMonitoring === 'where_i_been';
	const audioNoEdition = !isTrackOrWhereIBenn ? dataToEdit.files.find((file) => file.type === 'audio') ?? {} : {};

	useEffect(() => {
		const imagensNoEdition = !isTrackOrWhereIBenn ? dataToEdit.files.filter((file) => file.type === 'image') ?? [] : [];
		if (imagensNoEdition && imagensNoEdition?.length > 0) {
			setIsImages(imagensNoEdition);
		}

		if (audioNoEdition && audioNoEdition?.signedUrl) {
			setAudioByMonitoring({
				uri: audioNoEdition.signedUrl,
				name: audioNoEdition.name,
				type: audioNoEdition.type,
				hash: audioNoEdition.hash
			});
		} else {
			setAudioByMonitoring({});
		}
	}, [dataToEdit]);

	useEffect(() => {
		setLat(coordinates?.latitude || '');
		setLong(coordinates?.longitude || '');
	}, [coordinates]);

	useEffect(() => {
		if (olMap()) {
			const vectorSource = olMap()
				?.getLayers()
				.getArray()
				.find((layer) => layer.get('name') === 'monitoring')
				.getSource();

			const pointFeature = vectorSource?.getFeatures()[0];
			// define the source and target projections
			const sourceProjection = 'EPSG:4326'; // WGS84
			const targetProjection = 'EPSG:3857'; // Web Mercator
			if (pointFeature) {
				const transformedCoordinates = transform([long, lat], sourceProjection, targetProjection);

				pointFeature.getGeometry().setCoordinates(transformedCoordinates);

				const extentIt = pointFeature.getGeometry().getExtent();
				if (extent) {
					olMap()
						.getView()
						.fit(extentIt, { padding: [50, 50, 50, 50] });
					setExtent(false);
				}
			}
		}
	}, [long, lat, olMap(), extent]);

	// Função para processar os arquivos e retornar o filesInfos
	function processFiles() {
		const filesInfos = [];

		// Processar áudio
		if (audioRecorderFile) {
			// Novo áudio foi gravado
			const audioHash = generateHash(audioRecorderFile);
			filesInfos.push({
				filename: audioRecorderFile.name,
				hash: audioHash
			});
		} else if (Object.keys(audioByMonitoring).length > 0) {
			// O áudio original não foi alterado
			filesInfos.push({
				filename: audioByMonitoring.name,
				hash: audioByMonitoring.hash
			});
		}

		// Processar imagens
		isImages.forEach((image) => {
			if (image.hash) {
				// Imagem existente, não foi alterada
				filesInfos.push({
					filename: image.name,
					hash: image.hash
				});
			} else if (image.file) {
				// Nova imagem, gerar novo hash
				const imageHash = generateHash(image.file);
				filesInfos.push({
					filename: image.file.name,
					hash: imageHash
				});
			}
		});

		return filesInfos;
	}

	// UseEffect para atualizar `imagesFiles` sempre que `isImages` mudar
	useEffect(() => {
		const newImageFiles = isImages.filter((image) => image.file); // Filtra apenas as novas imagens
		setImagesFiles(newImageFiles.map((image) => image.file)); // Atualiza o estado com os novos arquivos
	}, [isImages]);

	function saveAlert(event) {
		event.preventDefault();
		const date = new Date();

		if (typeSelected === '' && type !== 'whereIBeen') {
			setTypeSelectedEmpty(true);
			return;
		}
		setTypeSelectedEmpty(false);

		if (nameWhereIBeen === '' && (type === 'whereIBeen' || type === 'tracker')) {
			setNameWhereIBeenEmpty(true);
			return;
		}
		setNameWhereIBeenEmpty(false);

		if (routeMonitoring !== 'tracks' && (!isLatitude(lat) || !isLongitude(long))) {
			setLocationEmpty(true);
			return;
		}
		setLocationEmpty(false);

		// OBJETO COM OS DADOS DE REGISTRO DE ALERTA
		const objToSave = {
			controllerWebFile: true, // estado para o controle de upload de file web
			id,
			hash: dataToEdit.hash,
			name: typeSelected.label ? typeSelected?.label.toUpperCase() : nameWhereIBeen,
			type: typeSelected.value,
			description,
			latitude: lat,
			longitude: long,
			updated_at: date.toISOString(),
			filesInfos: processFiles(),
			audio: audioRecorderFile,
			image: imagesFiles
		};

		if (isTrackOrWhereIBenn) {
			delete objToSave.description;
			delete objToSave.type;
			delete objToSave.audio;
			delete objToSave.image;
		}

		if (routeMonitoring === 'tracks') {
			delete objToSave.latitude;
			delete objToSave.longitude;
		}

		dispatch(
			editDataMonitoring({
				params: isTrackOrWhereIBenn ? objToSave : createFormData(objToSave),
				route: isRouteEditMonitoring(routeMonitoring),
				typeAlert: routeMonitoring
			})
		);

		// essas funções devem ser executadas se a requisição der certo
		dispatch(finishEdit());
		clearVector('monitoring');
		setTimeout(() => {
			dispatch(onLoadMonitoring(dataUser));
		}, 500);
	}

	// popula no formulário dados que ja existem no alerta que vai ser editado
	useEffect(() => {
		setId(dataToEdit.id);
		setLat(dataToEdit.latitude);
		setLong(dataToEdit.longitude);
		setDescription(dataToEdit.description);
		setNameWhereIBeen(dataToEdit.name);
	}, [dataToEdit]);

	useEffect(() => {
		if (listType.length > 0) {
			const filterType = listType.filter((item) => item.id === dataToEdit.type);
			const newObj = { value: filterType[0].id, label: filterType[0].nome };
			setTypeSelected(newObj);
		}
	}, [listType]);

	// responsável por carregar a lista dos tipos do alerta ou uso tradicional que será cadastrado
	useEffect(() => {
		listTypeRegister(type, setListType);
	}, [type]);

	const content = [
		{
			id: 0,
			p: '- Clique no ponto azul no centro do icone e arraste para alterar a localização'
		},
		{
			id: 2,
			p: '- Digitando as coordenadas geográficas.'
		}
	];

	const latDMS = getDMS(lat, 'lat');
	const lonDMS = getDMS(long, 'long');
	useEffect(() => {
		setGms(`${latDMS} ${lonDMS}`);
	}, []);
	useEffect(() => {
		if (latDMS || (lonDMS && !isOnchangeGms)) setGms(`${latDMS} ${lonDMS}`);
	}, [latDMS, lonDMS]);

	const onchangeGms = (e) => {
		try {
			const result = convertLatLong(e.target.value);

			if (result && result.length >= 2) {
				const latitude = result[0].ltCoord.toFixed(6);
				const longitude = result[1].longCoord.toFixed(6);
				setisOnchangeGms(true);
				setExtent(true);
				setLat(latitude);
				setLong(longitude);
				setGms(e.target.value);
			}
		} catch (err) {
			console.log(err);
		}
	};

	const onchangeCoord = (e) => {
		if (e.target.name === 'long') {
			setExtent(true);
			setisOnchangeGms(false);
			setLong(e.target.value);
		} else {
			setExtent(true);
			setisOnchangeGms(false);
			setLat(e.target.value);
		}
	};

	if (loadingUpdate) return <Load />;

	return (
		<form style={{ paddingBottom: '20rem' }} onSubmit={saveAlert}>
			<S.containerAdd>
				{type !== 'whereIBeen' && type !== 'tracker' ? (
					<S.itemForm>
						<p>Tipo do {type === 'alert' ? 'alerta' : 'uso tradional'}:</p>
						<Select
							style={styles.select}
							options={listType}
							itemSelected={typeSelected}
							setItemSelected={setTypeSelected}
						/>
						{typeSelectedEmpty ? <S.errorInputEmpity>*Favor preencher o tipo do registro.</S.errorInputEmpity> : null}
					</S.itemForm>
				) : null}
				{type === 'whereIBeen' || type === 'tracker' ? (
					<S.itemForm>
						<p>Nome do local:</p>
						<CustomInput
							styleInput={styles.input}
							value={nameWhereIBeen}
							setValue={setNameWhereIBeen}
							minLength={1}
							maxLength={35}
						/>
						{nameWhereIBeenEmpty ? <S.errorInputEmpity>*Favor preencher o nome do local</S.errorInputEmpity> : null}
					</S.itemForm>
				) : null}

				{type !== 'whereIBeen' && type !== 'tracker' ? (
					<S.itemForm>
						<p>Descrição do registro:</p>
						<CustomTextArea type="text" styleInput={styles.input} value={description} setValue={setDescription} />
					</S.itemForm>
				) : null}

				{type !== 'whereIBeen' && type !== 'tracker' ? (
					<S.itemForm>
						<p>Gravar áudio:</p>

						{/* Encontra o arquivo de áudio no array de arquivos */}
						{audioNoEdition?.signedUrl ? (
							<AudioRecorder
								isAudio={audioNoEdition}
								audioRecorderFile={audioRecorderFile}
								setAudioRecorderFile={setAudioRecorderFile}
								audioByMonitoring={audioByMonitoring}
								setAudioByMonitoring={setAudioByMonitoring}
							/>
						) : (
							<AudioRecorder audioRecorderFile={audioRecorderFile} setAudioRecorderFile={setAudioRecorderFile} />
						)}
					</S.itemForm>
				) : null}

				{routeMonitoring !== 'tracks' ? (
					<>
						<S.itemForm style={{ paddingTop: 10 }}>
							<p>Obter coordenadas em Graus Decimais (GD):</p>
							<BalloonDoubtsGlobal positionRight={5} header="Formas para editar a localização" content={content} />
							<S.itemLocation>
								<CustomInput
									type="number"
									placeholder="Latitude"
									styleInput={styles.input}
									name="lat"
									value={lat}
									useOnChange
									onChange={onchangeCoord}
								/>

								<CustomInput
									type="number"
									placeholder="Longitude"
									styleInput={styles.input}
									value={long}
									name="long"
									useOnChange
									onChange={onchangeCoord}
								/>
							</S.itemLocation>
							<S.itemLocation>
								<p>Coordenadas geográficas</p>
							</S.itemLocation>
							{locationEmpty ? (
								<S.errorInputEmpity>
									{long === '' || lat === ''
										? 'Os campos latitude e longitude são obrigatórios.'
										: isCoordsInvalid(isLatitude(lat), isLongitude(long))}
								</S.errorInputEmpity>
							) : null}
						</S.itemForm>
						<S.itemForm style={{ paddingTop: 0 }}>
							<p>Obter coordenadas em Graus, Minutos e Segundos (GMS):</p>

							<S.itemLocation>
								<CustomInput
									type="text"
									placeholder={gms}
									styleInput={styles.input}
									value={gms}
									onChange={onchangeGms}
									setValue={setGms}
									useOnChange
								/>
							</S.itemLocation>
							<S.itemLocation>
								<p>Coordenadas geográficas</p>
							</S.itemLocation>
							{locationEmpty ? (
								<S.errorInputEmpity>
									{long === '' || lat === ''
										? 'Os campos latitude e longitude são obrigatórios.'
										: isCoordsInvalid(isLatitude(lat), isLongitude(long))}
								</S.errorInputEmpity>
							) : null}
						</S.itemForm>
					</>
				) : null}

				{type !== 'whereIBeen' && type !== 'tracker' ? (
					<S.itemForm>
						<ImageUploading setIsImages={setIsImages} isImages={isImages} />
					</S.itemForm>
				) : null}

				<S.btnSalvar type="submit">Salvar</S.btnSalvar>
			</S.containerAdd>
		</form>
	);
}

const styles = {
	input: {
		borderRadius: '8px',
		marginBottom: '0px',
		border: `1px solid ${color.interface.lightGray}`,
		backgroundColor: '#ffffff'
	},
	select: {
		height: '40px',
		border: `1px solid ${color.interface.lightGray}`,
		backgroundColor: '#ffffff'
	}
};
